export var StockTransferRequisitionAPIKeys = {
    create: 'stockTransferRequisitionCreate',
    update: 'stockTransferRequisitionUpdate',
    get: 'stockTransferRequisitionGetById',
    paging: 'stockTransferRequisitionPaging',
    statusProgress: 'stockTransferRequisitionStatusProgress',
    attachmentList: 'stockTransferRequisitionAttachmentList',
    downloadAttachmentList: 'stockTransferRequisitionDownloadAttachmentList',
    stockTransferRequisitionPartList: 'stockTransferRequisitionPartList',
    uploadAttachment: 'stockTransferRequisitionUploadAttachment',
    deleteAttachment: 'stockTransferRequisitionDeleteAttachment',
    AttachmentSystemName: 'InventoryAttachment'
};
export var showColumnName = {
    DocumentCode: "Document Number",
    DocumentDate: "Requisition Date",
    CreatedOn: "Created date",
    SourceWarehouseName: "Warehouse",
    TotalQuantity: "Total quantity",
    StatusName: "Status",
    TotalAmount: "Total amount"
};
export var StockTransferRequisitionFields = {
    'ProductId': 'Product',
    'RequestedQuantity': 'RequestedQuantity'
};
